import { ENVIRONMENT, BASE_URL, ENABLE_REDUX_LOGGER } from './local_settings';

const api_prefix: string = '/api/v1';
const minTableRowHeight: number = 5;
let environment: string = ENVIRONMENT;
let showReduxLogger: boolean = !!ENABLE_REDUX_LOGGER;
let backendURLPrefix: string = 'api-';
let baseHTTPURL: string = BASE_URL;
const { NODE_ENV } = process.env;
if (NODE_ENV === 'development') {
    environment = 'LOCAL';
    showReduxLogger = true;
    baseHTTPURL = 'https://api-boma-canada-aws.ibigroup.in/';
}

if (environment !== 'LOCAL') {
    if (environment === 'PRODUCTION') {
        backendURLPrefix = 'api.';
    }
    baseHTTPURL = `${window.location.protocol}//${backendURLPrefix}${window.location.host}`;
}

export { environment, baseHTTPURL, minTableRowHeight, api_prefix, showReduxLogger };
